// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"a6a23360","239":"43a26727","455":"0196be12","806":"69dab607","977":"118a9f06"}[chunkId] + ".chunk.js";
};